import { call, callPaginated } from "./client.js";

/**
 * Generic admin resource client. Phase 9 wires per-resource hooks on top.
 * Every admin resource follows the same /api/v1/admin/{resource} pattern, so
 * this single client serves them all.
 *
 *   await adminApi.list("designs", { collection: "plato-collection" });
 *   await adminApi.get("designs", id);
 *   await adminApi.create("designs", payload);
 *   await adminApi.update("designs", id, partial);
 *   await adminApi.remove("designs", id);
 */
export const adminApi = {
  list: (resource, params) => callPaginated(`/admin/${resource}`, params),
  get: (resource, id) => call("get", `/admin/${resource}/${id}`),
  create: (resource, body) => call("post", `/admin/${resource}`, { data: body }),
  update: (resource, id, body) => call("patch", `/admin/${resource}/${id}`, { data: body }),
  remove: (resource, id) => call("delete", `/admin/${resource}/${id}`),

  /** Sub-route helpers used by specific resources (designs reorder-images,
   * blogs status, facades reorder, users force-reset, etc.). */
  patchSubpath: (resource, id, sub, body) =>
    call("patch", `/admin/${resource}/${id}/${sub}`, { data: body }),
  postSubpath: (resource, sub, body) => call("post", `/admin/${resource}/${sub}`, { data: body }),
  patchTopSubpath: (resource, sub, body) =>
    call("patch", `/admin/${resource}/${sub}`, { data: body }),
};
